import React from 'react';
import {PostalCodeInputGroup} from "../validation/PostalCodeInputGroup";
import {SelectGroup} from "../base/SelectGroup";
import {RequiredInputGroup} from "../validation/RequiredInputGroup";
import {InputGroup} from "../base/InputGroup";
import {RequiredSelectGroup} from "../validation/RequiredSelectGroup";

export default function WrapperAddressInputs(data) {
    return class extends React.Component {
        constructor(props) {
            super(props);
            this.handlePostalCodeChange = this.handlePostalCodeChange.bind(this);
            this.handlePostalCodeBlur = this.handlePostalCodeBlur.bind(this);
            this.handleStateChange = this.handleStateChange.bind(this);
            this.handleStateBlur = this.handleStateBlur.bind(this);
            this.handleCityChange = this.handleCityChange.bind(this);
            this.handleCityBlur = this.handleCityBlur.bind(this);
            this.handleNeighbourhoodChange = this.handleNeighbourhoodChange.bind(this);
            this.handleNeighbourhoodBlur = this.handleNeighbourhoodBlur.bind(this);
            this.handleStreetChange = this.handleStreetChange.bind(this);
            this.handleStreetBlur = this.handleStreetBlur.bind(this);
            this.handleNumberChange = this.handleNumberChange.bind(this);
            this.handleNumberBlur = this.handleNumberBlur.bind(this);
            this.handleExtensionChange = this.handleExtensionChange.bind(this);
            this.handleExtensionBlur = this.handleExtensionBlur.bind(this);
            this.handleAddress = this.handleAddress.bind(this);
            this.handleRefillCity = this.handleRefillCity.bind(this);
            this.handlePostalCode = this.handlePostalCode.bind(this);
            this.handlePostalCodeAlertUpdate = this.handlePostalCodeAlertUpdate.bind(this);
            this.handleStateAlertUpdate = this.handleStateAlertUpdate.bind(this);
            this.handleCityAlertUpdate = this.handleCityAlertUpdate.bind(this);
            this.handleNeighbourhoodAlertUpdate = this.handleNeighbourhoodAlertUpdate.bind(this);
            this.handleStreetAlertUpdate = this.handleStreetAlertUpdate.bind(this);
            this.handleNumberAlertUpdate = this.handleNumberAlertUpdate.bind(this);
            this.handleExtensionAlertUpdate = this.handleExtensionAlertUpdate.bind(this);
            this.handleAlertUpdate = this.handleAlertUpdate.bind(this);
            this.checkDisabledInputs = this.checkDisabledInputs.bind(this);
            this.fillData = this.fillData.bind(this);
            this.state = {
                address: {
                    postalCode: {
                        id: props.address.postalCode.id || "addressPostalCode",
                        disabled: props.address.postalCode.disabled || false,
                        label: {name: props.address.postalCode.label.name || "CEP"},
                        required: props.address.postalCode.required || true,
                        value: props.address.postalCode.value,
                        title: props.address.postalCode.title || "CEP"
                    },
                    state: {
                        id: props.address.state.id || "addressState",
                        disabled: props.address.state.disabled || false,
                        label: {name: props.address.state.label.name || "Estado"},
                        required: props.address.state.required || true,
                        value: props.address.state.value,
                        title: props.address.state.title || "Estado",
                        options: []
                    },
                    city: {
                        id: props.address.city.id || "addressCity",
                        disabled: props.address.city.disabled || false,
                        label: {name: props.address.city.label.name || "Cidade"},
                        required: props.address.city.required || true,
                        value: props.address.city.value,
                        title: props.address.city.title || "Cidade",
                        options: []
                    },
                    neighbourhood: {
                        type: "text",
                        id: props.address.neighbourhood.id || "addressNeighbourhood",
                        disabled: props.address.neighbourhood.disabled || false,
                        label: {name: props.address.neighbourhood.label.name || "Bairro"},
                        required: props.address.neighbourhood.required || true,
                        value: props.address.neighbourhood.value,
                        title: props.address.neighbourhood.title || "Bairro"
                    },
                    street: {
                        type: "text",
                        id: props.address.street.id || "addressStreet",
                        disabled: props.address.street.disabled || false,
                        label: {name: props.address.street.label.name || "Rua/Avenida..."},
                        required: props.address.street.required || true,
                        value: props.address.street.value,
                        title: props.address.street.title || "Logradouro"
                    },
                    number: {
                        type: "text",
                        id: props.address.number.id || "addressNumber",
                        disabled: props.address.number.disabled || false,
                        label: {name: props.address.number.label.name || "Número"},
                        required: props.address.number.required || true,
                        value: props.address.number.value,
                        title: props.address.number.title || "Número"
                    },
                    extension: {
                        type: "text",
                        id: props.address.extension.id || "addressExtension",
                        disabled: props.address.extension.disabled || false,
                        label: {name: props.address.extension.label.name || "Complemento"},
                        required: props.address.extension.required || true,
                        value: props.address.extension.value,
                        title: props.address.extension.title || "Complemento"
                    },
                },
            };
        }

        async componentDidMount() {
            let state = Object.assign(this.state);
            const options = await data.fetchStates();
            state.address.state.options = options;
            this.setState(state);
            if(this.state.address.state.value) {
                await this.handleRefillCity(this.state.address.state.value);
            }
            await this.fillData(this.state.address.postalCode.value);
        }

        handlePostalCodeChange(value) {
            this.handleAddress("postalCode", value, "change");
        };

        handlePostalCodeBlur(value) {
            this.handleAddress("postalCode", value, "blur");
            this.handlePostalCode(value);
        };

        handleStateChange(value) {
            this.handleAddress("state", value, "change");
            this.handleAddress("city", "", "change");
            this.handleRefillCity(value);
        };

        handleStateBlur(value) {
            this.handleAddress("state", value, "blur");
            this.handleAddress("city", "", "blur");
        };

        handleCityChange(value) {
            this.handleAddress("city", value, "change");
        };

        handleCityBlur(value) {
            this.handleAddress("city", value, "blur");
        };

        handleNeighbourhoodChange(value) {
            this.handleAddress("neighbourhood", value, "change");
        };

        handleNeighbourhoodBlur(value) {
            this.handleAddress("neighbourhood", value, "blur");
        };

        handleStreetChange(value) {
            this.handleAddress("street", value, "change");
        };

        handleStreetBlur(value) {
            this.handleAddress("street", value, "blur");
        };

        handleNumberChange(value) {
            this.handleAddress("number", value, "change");
        };

        handleNumberBlur(value) {
            this.handleAddress("number", value, "blur");
        };

        handleExtensionChange(value) {
            this.handleAddress("extension", value, "change");
        };

        handleExtensionBlur(value) {
            this.handleAddress("extension", value, "blur");
        };

        handleAddress(key, value, type) {
            let state = Object.assign(this.state);
            state.address[key].value = value;
            this.setState(state);

            if (type === "change") {
                this.props.onChange(this.state.address);
            } else if (type === "blur") {
                this.props.onBlur(this.state.address);
            }
        };

        async handlePostalCode(value) {
            await this.fillData(value);
        }

        async fillData(value) {
            try {
                let state = Object.assign(this.state);
                state.address.postalCode.value = value;
                const fetchValues = await data.fetchFromPostalCode(this.props.config, value);
                if(!fetchValues) {
                    throw new Error("Fetched value undefined");
                }
                state.address.state.value = fetchValues.state;
                state.address.city.value = fetchValues.city;
                state.address.neighbourhood.value = fetchValues.neighbourhood;
                state.address.street.value = fetchValues.street;
                if(fetchValues.neighbourhood && fetchValues.street) {
                    this.handleNeighbourhoodAlertUpdate({});
                    this.handleStreetAlertUpdate({});
                }
                await this.handleRefillCity(fetchValues.state);
                this.setState(state);
                this.checkDisabledInputs();
            } catch (err) {
                console.log(err);
                let state = Object.assign(this.state);
                state.address.state.disabled = false;
                state.address.city.disabled = false;
                this.setState(state);
            }

        }

        checkDisabledInputs() {
            let state = Object.assign(this.state);
            state.address.state.disabled = state.address.state.value !== undefined && state.address.state.value !== "" && state.address.state.value !== null;
            state.address.city.disabled = state.address.city.value !== undefined && state.address.city.value !== "" && state.address.city.value !== null;
            this.setState(state);
        }

        async handleRefillCity(value) {
            let state = Object.assign(this.state);
            let options = await data.fetchCities(this.props.config, value);
            state.address.city.options = options;
            this.setState(state);
        }

        handlePostalCodeAlertUpdate(alert) {
            this.handleAlertUpdate("postalCode", alert);
        }
        handleStateAlertUpdate(alert) {
            this.handleAlertUpdate("state", alert);
        }
        handleCityAlertUpdate(alert) {
            this.handleAlertUpdate("city", alert);
        }
        handleNeighbourhoodAlertUpdate(alert) {
            this.handleAlertUpdate("neighbourhood", alert);
        }
        handleStreetAlertUpdate(alert) {
            this.handleAlertUpdate("street", alert);
        }
        handleNumberAlertUpdate(alert) {
            this.handleAlertUpdate("number", alert);
        }
        handleExtensionAlertUpdate(alert) {
            this.handleAlertUpdate("extension", alert);
        }

        handleAlertUpdate(prop, alert) {
            let alerts = Object.assign(this.props.alerts);
            alerts[prop] = alert;
            this.props.onAlertsUpdate(alerts);
        }

        render() {
            return (
                <div className="container">
                    <div className="row">
                        <div className="col-xs-6">
                            <PostalCodeInputGroup autoFocus={this.props.autoFocus} input={this.state.address.postalCode}
                                                  alert={this.props.alerts.postalCode}
                                                  onAlertUpdate={this.handlePostalCodeAlertUpdate}
                                                  onChange={this.handlePostalCodeChange}
                                                  onBlur={this.handlePostalCodeBlur} validateOn="blur"/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-2">
                            <RequiredSelectGroup input={this.state.address.state} alert={this.props.alerts.state}
                                         onAlertUpdate={this.handleStateAlertUpdate}
                                         onChange={this.handleStateChange} onBlur={this.handleStateBlur}
                                         validateOn="blur"/>
                        </div>
                        <div className="col-xs-4">
                            <RequiredSelectGroup input={this.state.address.city} alert={this.props.alerts.city}
                                         onAlertUpdate={this.handleCityAlertUpdate}
                                         onChange={this.handleCityChange} onBlur={this.handleCityBlur}
                                         validateOn="blur"/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-6">
                            <RequiredInputGroup input={this.state.address.neighbourhood}
                                                alert={this.props.alerts.neighbourhood}
                                                onAlertUpdate={this.handleNeighbourhoodAlertUpdate}
                                                onChange={this.handleNeighbourhoodChange}
                                                onBlur={this.handleNeighbourhoodBlur} validateOn="blur"/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-6">
                            <RequiredInputGroup input={this.state.address.street} alert={this.props.alerts.street}
                                                onAlertUpdate={this.handleStreetAlertUpdate}
                                                onChange={this.handleStreetChange} onBlur={this.handleStreetBlur}
                                                validateOn="blur"/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-2">
                            <RequiredInputGroup input={this.state.address.number} alert={this.props.alerts.number}
                                                onAlertUpdate={this.handleNumberAlertUpdate}
                                                onChange={this.handleNumberChange} onBlur={this.handleNumberBlur}
                                                validateOn="blur"/>
                        </div>
                        <div className="col-xs-4">
                            <InputGroup input={this.state.address.extension} alert={this.props.alerts.extension}
                                        onAlertUpdate={this.handleExtensionAlertUpdate}
                                        onChange={this.handleExtensionChange} onBlur={this.handleExtensionBlur}
                                        validateOn="blur"/>
                        </div>
                    </div>
                </div>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/input/inputs/WrapperAddressInputs.js